import { FC, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import DataTable from 'components/tables/data-table';
import { useAuth } from 'contexts';
import { defaultTransactionColumns, transactionDataColumns } from 'pages/transactions/grid/transaction-columns';
import { downloadTransactionsCsv, fetchTransactionsWithSpecifcation } from 'services';

const BookingTransactions: FC = () => {
  const { bookingId } = useParams();
  const { userProfile } = useAuth();

  const fetchData = useMemo(() => fetchTransactionsWithSpecifcation({ bookingId }), [bookingId]);
  const initialColumns = useMemo(() => {
    return userProfile.columnPreferences.filter(cp => cp.table === 'TRANSACTION').length > 0
      ? userProfile.columnPreferences
          .filter(cp => cp.table === 'TRANSACTION')
          .map(({ column, width }) => {
            return { field: column, width };
          })
      : defaultTransactionColumns.map(c => {
          return { field: c, width: 80 };
        });
  }, [userProfile.columnPreferences]);

  if (!bookingId) return null;

  return (
    <div className="card-primary">
      <div className="card-header px-3">
        <h4>TRANSACTIONS</h4>
      </div>
      <div className="card-body">
        <DataTable
          fetchData={fetchData}
          fetchCsv={downloadTransactionsCsv({ bookingId })}
          columns={transactionDataColumns}
          initialPage={{ pageNum: 0, pageSize: 100, sortField: 'completedDate', sortDirection: 'desc' }}
          initialColumns={initialColumns}
          csvFilename="Booking Transactions"
        />
      </div>
    </div>
  );
};

export default BookingTransactions;
